export const AlcoholCategoriesMenuOptions = [
  {
    header: {
      category: 'Explore Beer Category',
      path: 'categories/beer-hub'
    },
    listOfItems: [
      {
        itemText: 'Non-Alcoholic Beer',
        routeParams: {
          path: 'beer-hub/non-alcoholic'
        }
      },
      {
        itemText: 'Malts & Ices',
        routeParams: {
          path: 'beer-hub/malts-ices'
        }
      },
      {
        itemText: 'American Classics',
        routeParams: {
          path: 'beer-hub/american-classic'
        }
      },
      {
        itemText: 'American Lights',
        routeParams: {
          path: 'beer-hub/american-light'
        }
      },
      {
        itemText: 'American Balanced Choices',
        routeParams: {
          path: 'beer-hub/american-balanced'
        }
      }
    ]
  },
  {
    listOfItems: [
      {
        itemText: 'Import Styles',
        routeParams: {
          path: 'beer-hub/imports'
        }
      },
      {
        itemText: 'Premium Favorites',
        routeParams: {
          path: 'beer-hub/premium-favorites'
        }
      },
      {
        itemText: 'IPA/Pale Ales',
        routeParams: {
          path: 'beer-hub/ipa-pale-ale'
        }
      },
      {
        itemText: 'Craft Varieties',
        routeParams: {
          path: 'beer-hub/craft-varieties'
        }
      },
      {
        itemText: 'Flavored Beer',
        routeParams: {
          path: 'beer-hub/flavored'
        }
      }
    ]
  },
  {
    header: {
      category: 'Explore Hard Beverage Category',
      path: 'categories/hard-bev-hub'
    },
    listOfItems: [
      {
        itemText: 'Seltzers',
        routeParams: {
          path: 'hard-bev-hub/seltzers'
        }
      },
      {
        itemText: 'Teas & Lemonades',
        routeParams: {
          path: 'hard-bev-hub/teas-lemonades'
        }
      },
      {
        itemText: 'Sweet FABs: Lower-ABV',
        routeParams: {
          path: 'hard-bev-hub/sweet-fabs'
        }
      },
      {
        itemText: 'Sweet FABs: Higher-ABV',
        routeParams: {
          path: 'hard-bev-hub/higher-abv-fabs'
        }
      }
    ]
  },
  {
    listOfItems: [
      {
        itemText: 'Spirit-Based Cocktails',
        routeParams: {
          path: 'hard-bev-hub/spirit-based-cocktails'
        }
      },
      {
        itemText: 'Shareables',
        routeParams: {
          path: 'hard-bev-hub/shareables'
        }
      },
      {
        itemText: 'Ciders',
        routeParams: {
          path: 'hard-bev-hub/ciders'
        }
      }
    ]
  }
];
